// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EKGt","col":"styles_col__dGLwf"};